import React, { useEffect, lazy, Suspense } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import GeneralInformation from './Components/GeneralInformation';
import Contract from './Components/Contract';
import CompanyProfile from './Components/CompanyProfile';
import BiddingScreen from './Components/AuctionPortal/BIddingScreen/BiddingScreen';
import LandingPageV2 from './Components/AuctionPortal/LandingPage/LandingPagev2';
import Indent from './Components/Indent/Indent';
import AdvancedBiddingScreen from './Components/AuctionPortal/BIddingScreen/AdvancedBiddingScreen';
import ReactGA from "react-ga4";
import { GOOGLE_ID } from "./config/env.config";

const BusinessProfile = lazy(() => import('./Components/BusinessProfile'));
const OperationsOverview = lazy(() => import('./Components/OperationsOverview'));
const CustomerDetails = lazy(() => import('./Components/CustomerDetails'));
// const Tender = lazy(() => import('./Components/Tender'));
const Clientscreen = lazy(() => import('./Components/TransporterClientScreen'));
const ActiveProcurement = lazy(() => import('./Components/ActiveProcurement/ActiveProcurement'));
const History = lazy(() => import('./Components/AuctionPortal/LandingPage/History'));
const Trucks = lazy(() => import('./Components/TruckAvailability/Trucks'));
const AccessControl = lazy(() => import('./Components/AccessControl/AccessControl'));

const RFQ = lazy(() => import('./Components/RFQ'));
const UploadedRateCard = lazy(() => import('./Components/RateCard/UploadedRateCard'));
const LotRateCard = lazy(() => import('./Components/RateCard/LotRateCard'));
const DhandhaNowFunc = lazy(() => import('./Components/DhandhaNow/DhandhaNowFunc'));
const ClosedProcurement = lazy(() => import('./Components/ClosedProcurement/ClosedProcurement'));
const LocationDashboard = lazy(() => import('./Components/LocationDashboard'));
const Dashboard = lazy(() => import('./Components/Dashboard/Dashboard'));
const InterestExpression = lazy(() => import('./Components/InterestExpression'));
const DhandhaNowV1 = lazy(() => import('./Components/DhandhaNow/DhandhaNowV1/DhandhaNowV1'));
const Enquiries = lazy(() => import('./Components/Enquiries/Enquiries'));

const gaId = GOOGLE_ID;
ReactGA.initialize(gaId);

const RouterOutlet = ({ policyLandingPage }) => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <Suspense fallback={<div></div>}>
      <Switch>
        <Route path="/businessProfile" component={BusinessProfile} />
        <Route path="/operationsOverview" component={OperationsOverview} />
        <Route path="/customerDetails" component={CustomerDetails} />
        <Route path="/generalInfo" component={GeneralInformation} exact />
        <Redirect from="/" to={policyLandingPage} exact />
        <Route path="/contract" component={Contract} exact />
        <Route path="/RFQ" component={RFQ} exact />
        <Route path="/LaneIntelligence" component={DhandhaNowFunc} exact />
        <Route path="/RFQ/:name" component={RFQ} exact />
        <Route path='/profile' component={CompanyProfile} exact />
        <Route path='/profile/:id' component={CompanyProfile} exact />
        {/* Old module */}
        {/* <Route path='/tender' component={Tender} exact /> */}
        <Route path='/MyProfile' component={Clientscreen} exact />
        <Route path='/expression-of-interest' component={InterestExpression} exact />
        <Route path='/expression-of-interest-old' component={DhandhaNowV1} exact />
        <Route path='/LocationIntelligence' component={LocationDashboard} exact />
        <Route path='/enquiries' component={Enquiries} exact />
        <Route path='/ratecard' component={UploadedRateCard} exact />
        <Route path='/ratecardeditable' component={LotRateCard} exact />
        <Route path='/activeprocurement' component={ActiveProcurement} exact />
        <Route path='/closedprocurement' component={ClosedProcurement} exact />
        <Route path='/Bidding' component={BiddingScreen} exact />
        <Route path='/Bidding/:name' component={BiddingScreen} exact />
        <Route path='/Advanced_Bidding/:name' component={AdvancedBiddingScreen} exact />
        <Route path='/auction' component={LandingPageV2} exact />
        <Route path='/history' component={History} exact />
        <Route path='/trucks' component={Trucks} exact />
        <Route path='/indents/:id' component={Indent} />
        <Route path='/indents' component={Indent} />
        <Route path="/dashboard" component={Dashboard} exact />
        <Route path='/access-control' component={AccessControl} exact />
      </Switch>
    </Suspense>
  );
};

export default RouterOutlet;
